<!-- Fundo escurecido no mobile -->
@if (aberto) {
  <div class="overlay lg:hidden" (click)="fechar.emit()"></div>
}

<aside class="sidebar" [class.aberta]="aberto">
  <div class="h-16 flex items-center justify-between px-6 border-b border-gray-100 flex-shrink-0">
    <a [routerLink]="['/home']" (click)="aoNavegar()">
      <glico-logo [animar]="true" classeNome="text-xl"></glico-logo>
    </a>
    <span class="text-[10px] font-extrabold uppercase tracking-wider text-glico-verde_escuro bg-glico-verde_claro rounded-full px-2 py-0.5">
      Gestão
    </span>
  </div>

  <nav class="flex-1 overflow-y-auto px-3 py-5 space-y-1">
    @for (menu of listMenu; track menu.label; let i = $index) {
      @if (menu.type == 'title') {
        <a
          class="item escalonado"
          [style.--i]="i"
          [routerLink]="['/', menu.route!]"
          routerLinkActive="ativo"
          (click)="aoNavegar()"
        >
          <mat-icon class="icone" [fontIcon]="icone(menu.label)"></mat-icon>
          <span>{{ menu.label }}</span>
        </a>
      } @else if (menu.type == 'subTitle' && menu.children!.length > 0) {
        <button
          type="button"
          class="item escalonado w-full"
          [style.--i]="i"
          [class.grupo-aberto]="menuSelected == menu.label"
          (click)="menuToggle(menu.label)"
        >
          <mat-icon class="icone" [fontIcon]="icone(menu.label)"></mat-icon>
          <span class="flex-1 text-left">{{ menu.label }}</span>
          <mat-icon class="seta" fontIcon="expand_more"></mat-icon>
        </button>
        <div class="submenu-items" [class.expanded]="menuSelected == menu.label">
          <div class="submenu-inner">
            @for (subItem of menu.children; track subItem.route) {
              <a
                class="submenu-item"
                [routerLink]="['/', subItem.route!]"
                routerLinkActive="ativo"
                (click)="aoNavegar()"
              >
                {{ subItem.label }}
              </a>
            }
          </div>
        </div>
      }
    }
  </nav>

  <!-- Card de marca (manual: card verde com CTA) -->
  @if (permissions.includes('view-dashboard-gestao')) {
    <div class="p-4 flex-shrink-0">
      <div class="bg-glico-verde rounded-2xl p-4 text-white relative overflow-hidden">
        <svg class="gota-deco absolute -right-4 -bottom-4 w-20 h-20 opacity-20" fill="currentColor" viewBox="0 0 100 100" aria-hidden="true">
          <path d="M50 10C50 10 20 45 20 65C20 81.56 33.43 95 50 95C66.57 95 80 81.56 80 65C80 45 50 10 50 10Z" />
        </svg>
        <p class="relative text-sm font-bold leading-snug">Pacientes aguardando retorno da equipe.</p>
        <a
          [routerLink]="['/alertas-pendentes']"
          (click)="aoNavegar()"
          class="relative mt-3 inline-block bg-white text-glico-verde font-bold py-1.5 px-4 rounded-full text-xs hover:bg-gray-50 transition-colors"
        >
          Ver pendências
        </a>
      </div>
    </div>
  }
</aside>
